export default __webpack_public_path__ + "static/media/todolist.5c6876be.png";